import React from 'react'
import { Box, NativeSelect } from '@mantine/core'

export type ProfileTabBarProps = {
  tabs: string[];
  activeTab: string;
  onChange: (tab: string) => void;
  mobile?: boolean;
}

function formatTabLabel (value: string) {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export default function ProfileTabBar ({ tabs, activeTab, onChange, mobile }: ProfileTabBarProps) {
  if (mobile) {
    return (
      <Box
        sx={{
          boxSizing: 'border-box',
          background: 'var(--gs-surface)',
          borderBottom: '1px solid var(--gs-border)',
          paddingLeft: 'var(--gs-md)',
          paddingRight: 'var(--gs-md)',
          paddingTop: 10,
          paddingBottom: 10
        }}
      >
        <NativeSelect
          value={activeTab}
          onChange={(e) => onChange(e.currentTarget.value)}
          data={tabs.map((t) => ({ value: t, label: formatTabLabel(t) }))}
          styles={{
            input: {
              fontFamily: 'DM Sans, sans-serif',
              fontWeight: 500,
              borderColor: 'var(--gs-border)',
              backgroundColor: 'var(--gs-bg)'
            }
          }}
        />
      </Box>
    )
  }

  return (
    <Box
      sx={{
        boxSizing: 'border-box',
        background: 'var(--gs-surface)',
        borderBottom: '1px solid var(--gs-border)',
        paddingLeft: 'var(--gs-md)',
        paddingRight: 'var(--gs-md)',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'stretch',
        gap: 0,
        rowGap: 2
      }}
    >
      {tabs.map((value) => {
        const active = activeTab === value
        return (
          <Box
            key={value}
            component="button"
            type="button"
            onClick={() => onChange(value)}
            sx={{
              fontFamily: 'DM Sans, sans-serif',
              fontSize: 'clamp(11px, 2.2vw, 13px)',
              color: active ? 'var(--gs-accent)' : 'var(--gs-muted)',
              borderTop: 'none',
              borderLeft: 'none',
              borderRight: 'none',
              borderBottom: active ? '2px solid var(--gs-accent)' : '2px solid transparent',
              padding: '10px 12px',
              marginBottom: -1,
              cursor: 'pointer',
              background: 'none',
              whiteSpace: 'nowrap',
              flexShrink: 0
            }}
          >
            {formatTabLabel(value)}
          </Box>
        )
      })}
    </Box>
  )
}
